import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function getSiteNames() {
    // Get a list of all site names

    try {
        const res = await axios.get(`${API_BASE_URL}/get-site-names`);
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}


export async function getOutflowComp(site: string, fromDate: string, toDate: string) {
    // API request to get Outflow Compare Results
    const params = new URLSearchParams();
    params.append("site", site);
    params.append("fromDate", fromDate);
    params.append("toDate", toDate);

    try {
        const res = await axios.get(`${API_BASE_URL}/outflow-compare`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}


export async function getOutflowCompSingleDate(site: string, date: string) {
    // API request to get Outflow Compare Results
    const params = new URLSearchParams();
    params.append("site", site);
    params.append("date", date)

    try {
        const res = await axios.get(`${API_BASE_URL}/outflow-compare-single-date`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}


export async function getDailyReconSnapshot(site: string, date: string) {
    // API request to get Outflow Compare Results
    const params = new URLSearchParams();
    params.append("siteName", site);
    params.append("date", date);

    try {
        const res = await axios.get(`${API_BASE_URL}/daily-recon-snapshot`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }

}


export async function getDailyReconDips(site: string, date: string) {
    // API request to get Outflow Compare Results
    const params = new URLSearchParams();
    params.append("siteName", site);
    params.append("date", date);

    try {
        const res = await axios.get(`${API_BASE_URL}/daily-recon-dips-levels`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }

}

export async function getShiftReport(site: string, fromDate: string, toDate: string) {
    // API request to get Shift Report Data
    const params = new URLSearchParams();
    params.append("siteName", site);
    params.append("fromDate", fromDate);
    params.append("toDate", toDate);

    try {
        const res = await axios.get(`${API_BASE_URL}/shift-report2`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }

}

export async function getShiftReport2(site: string, fromDate: string, toDate: string) {
    // API request to get Shift Report Data
    const params = new URLSearchParams();
    params.append("siteName", site);
    params.append("fromDate", fromDate);
    params.append("toDate", toDate);

    try {
        const res = await axios.get(`${API_BASE_URL}/shift-report2`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }

}